// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import type { RouteComponentProps } from 'react-router-dom'

import PageView from 'syft-acp-core/components/PageView'
import { WorkerBlocksList } from 'syft-acp-core/entities/WorkerDetail/WorkerBlocksList'
import { WorkerSubNavigation } from './SubNavigation'

type Props = RouteComponentProps<{
  id: string
}>

export const EntityWorkersBlocksList = ({ match: { params } }: Props) => (
  <>
    <WorkerSubNavigation workerID={params.id} />
    <PageView title={[`Blocks for worker ${params.id}`]}>
      <WorkerBlocksList workerID={Number(params.id)} />
    </PageView>
  </>
)
